import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { flow } from 'lodash';
import { storeInput, storeCompletion } from '../store/task';

const mapStateToProps = state => ({
  input: state.task.input,
  completed: state.task.completed
});

const mapDispatchToProps = dispatch => ({
  onInput: (id, payload) => {
    dispatch(storeInput(id, payload));
  },
  onCompletion: id => {
    dispatch(storeCompletion(id));
  }
});

export default function(WrappedComponent) {
  const UserInput = ({
    match,
    input,
    correctInput,
    onInput,
    completed,
    onCompletion,
    history,
    location,
    showingCorrectAnswer,
    ...passThroughProps
  }) => {
    let userInput = input[match.path] || null;
    if (showingCorrectAnswer) {
      userInput = correctInput;
    }

    const handleInput = payload => {
      onInput(match.path, payload);
    };

    const handleCompletion = () => {
      if (!completed.includes(match.path)) {
        onCompletion(match.path);
      }
    };

    return (
      <WrappedComponent
        onInput={handleInput}
        onCompletion={handleCompletion}
        input={userInput}
        correctInput={correctInput}
        {...passThroughProps}
      />
    );
  };

  UserInput.propTypes = {
    match: PropTypes.objectOf(PropTypes.any).isRequired,
    input: PropTypes.objectOf(PropTypes.any).isRequired,
    onInput: PropTypes.func.isRequired,
    onCompletion: PropTypes.func.isRequired,
    completed: PropTypes.arrayOf(PropTypes.string)
  };

  return flow(connect(mapStateToProps, mapDispatchToProps), withRouter)(
    UserInput
  );
}



// WEBPACK FOOTER //
// ../core/src/hocs/UserInput.js